import { Link as RouterLink } from 'react-router-dom'
import { Link } from '@mui/material'

import { HealthCheckList, HelperWrapper } from 'src/components'
import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'

import { useStyles } from './styles'

export const HealthCheckExternal = () => {
  const classes = useStyles()

  return (
    <main className={classes.containerSt}>
      <div className={classes.wrapperSt}>
        <Link
          className={classes.linkSt}
          to={joinAbsRoute(ROUTES.HEALTH_CHECK)}
          component={RouterLink}
        >
          <HelperWrapper t="go-back-button-text" />
        </Link>
        <HealthCheckList withoutRedirect />
      </div>
    </main>
  )
}

export default HealthCheckExternal
